var map = {
	"./1 bg banner.png": 6935,
	"./bagiconimg.png": 3973,
	"./banner1.jpg": 7088,
	"./banner2.jpg": 703,
	"./line.svg": 9505,
	"./login.svg": 1514,
	"./mcaprintwala.png": 2740,
	"./plus.svg": 1363,
	"./register.svg": 948,
	"./t-shirt.jpg": 9160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2180;